module.exports = __webpack_public_path__ + "media/09_ASANBUDAPEST-Atmosphere09.48d5d589.mp3";